export const stateCodes = {
  new: 'NUEVO',
  attended: 'ATENDIDO',
  inProgress: 'EN PROCESO',
  observed: 'OBSERVADO',
  resolved: 'SUBSANADO',
  rejected: 'RECHAZADO',
  archived: 'ARCHIVADO'
}

export const answerStates = [
  {
    code: stateCodes.new,
    name: 'Nuevo',
    tagType: 'secondary',
    citizenName: 'Envío de solicitud',
    citizenStepName: 'Recibida'
  },
  { code: stateCodes.attended, name: 'Atendido', tagType: 'success', citizenName: 'Atendida' },
  { code: stateCodes.inProgress, name: 'En proceso', tagType: 'primary', citizenName: 'En proceso' },
  { code: stateCodes.observed, name: 'Observado', tagType: 'warning', citizenName: 'Observada' },
  { code: stateCodes.resolved, name: 'Subsanado', tagType: 'info', citizenName: 'Observaciones subsanadas' },
  { code: stateCodes.rejected, name: 'Rechazado', tagType: 'neutral', citizenName: 'Rechazada' },
  { code: stateCodes.archived, name: 'Archivado', tagType: 'neutral', citizenName: 'Archivada' }
]

const titleBase = 'Explica el motivo por el cual la solicitud'
export const changeStateMessage = {
  [stateCodes.attended]: {
    title: `${titleBase} será marcada como atendida`,
    descriptionList: [
      'El cambio de estado se mostrará en el seguimiento del trámite para que el ciudadano pueda consultarlo.',
      'Esta información también quedará registrada como historial interno para tu entidad, pero no generará una notificación automática.'
    ],
    citizenMessage:
      'Explica qué acción resolvió la solicitud (por ejemplo, si se envió el documento o se brindó la información solicitada). Indica también por qué canal se dejó la respuesta formal (correo, presencial, plataforma externa, etc.).',
    citizenMessageRequired: false
  },
  [stateCodes.inProgress]: {
    title: `${titleBase} será marcada como en proceso`,
    descriptionList: [
      'El cambio de estado se mostrará en el seguimiento del trámite para que el ciudadano pueda consultarlo.',
      'Esta información también quedará registrada como historial interno para tu entidad, pero no generará una notificación automática.'
    ],
    citizenMessage:
      'Informa que la solicitud está siendo evaluada y, si aplica, menciona el plazo estimado de respuesta o canal para consultas. Si ya se contactó al ciudadano, indícalo.',
    citizenMessageRequired: false
  },
  [stateCodes.rejected]: {
    title: `${titleBase} será rechazada`,
    descriptionList: [
      'El cambio de estado se mostrará en el seguimiento del trámite para que el ciudadano pueda consultarlo.',
      'Debes incluir el motivo del rechazo para que quede registrado en el historial del trámite. Esta información será visible para el ciudadano, pero no generará una notificación automática.'
    ],
    citizenMessage:
      'Justifica el motivo del rechazo y, si aplica, señala si el ciudadano puede volver a presentar la solicitud o apelar. Indica si ya se informó por otro canal.',
    citizenMessageRequired: true
  },
  [stateCodes.resolved]: {
    title: `${titleBase} será marcada como subsanada`,
    descriptionList: [
      'El cambio de estado se mostrará en el seguimiento del trámite para que el ciudadano pueda consultarlo.',
      'Esta información también quedará registrada como historial interno para tu entidad, pero no generará una notificación automática.'
    ],
    citizenMessage:
      'Señala qué información fue recibida y cómo se corrigió lo observado. Indica si se continuará con el trámite y por qué medio se comunicó la validación.',
    citizenMessageRequired: false
  },
  [stateCodes.observed]: {
    title: `${titleBase} será observada`,
    descriptionList: [
      'El cambio de estado se mostrará en el seguimiento del trámite para que el ciudadano pueda consultarlo.',
      'Debes incluir el motivo de la observación para que el ciudadano sepa qué debe corregir. Esta información será parte del historial del trámite, sin generar una notificación automática.'
    ],
    citizenMessage:
      'Explica con claridad qué falta corregir o enviar, y cómo puede hacerlo el ciudadano. Menciona también los canales habilitados para subsanar (correo, formulario, WhatsApp, etc.).',
    citizenMessageRequired: true
  },
  [stateCodes.archived]: {
    title: `${titleBase} será archivada`,
    descriptionList: [
      'El estado será visible en el seguimiento del trámite.',
      'Debes incluir el motivo del archivado para dejar constancia clara del cierre del trámite. Esta información será parte del historial interno de tu entidad, pero no generará una notificación automática.'
    ],
    citizenMessage:
      'Indica por qué se archivó la solicitud (por ejemplo, fue anulada, duplicada, sin requerimiento adicional o no correspondía a la entidad). Si ya se informó por otro medio, señálalo.',
    citizenMessageRequired: true
  }
}

export const getStateByCode = code => answerStates.find(el => el.code === code)
